import React from 'react';

import { Tags } from '@/shared/components/ui/tags/tags';

export const useFormTagsInputAdornment = () => {
  const getSlotProps = (tags?: string[], onDelete?: (tag: string) => void) => {
    if (!tags?.length || tags.length === 0) {
      return undefined;
    }

    return {
      input: {
        startAdornment: (
          <Tags
            tags={tags.map((tag) => ({ name: tag }))}
            visibleTags={3}
            onDelete={({ name }) => onDelete?.(name)}
          />
        ),
      },
    };
  };

  return {
    getSlotProps,
  };
};
